import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, Network, ShieldCheck } from "lucide-react";

export default function TopNav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const handleLogout = async () => { await logout(); nav("/"); };

  return (
    <header className="sticky top-0 z-30 backdrop-blur-xl bg-black/60 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <img src="/asiyanna-logo.jpg" alt="asiyanna" className="w-8 h-8 rounded-lg object-cover" />
          <span className="font-display font-bold tracking-tight text-lg lowercase">asiyanna</span>
        </Link>
        <div className="flex items-center gap-3">
          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin-link" className="text-xs uppercase tracking-[0.2em] text-muted-foreground hover:text-primary transition-colors flex items-center gap-1">
              <ShieldCheck className="w-3.5 h-3.5" /> Admin
            </Link>
          )}
          {user && user.role !== "admin" && (
            <Link to="/dashboard" data-testid="nav-dashboard-link" className="text-xs uppercase tracking-[0.2em] text-muted-foreground hover:text-primary transition-colors">
              Dashboard
            </Link>
          )}
          <Button
            data-testid="nav-logout-btn"
            onClick={handleLogout}
            variant="ghost"
            size="sm"
            className="rounded-full hover:bg-white/5 hover:text-primary"
          >
            <LogOut className="w-4 h-4 mr-1" /> Logout
          </Button>
        </div>
      </div>
    </header>
  );
}
